// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__nLvrf {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_optionsWrapper__d4hUf {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.styles_error__GsRv5 {
  margin-top: 8px;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-align: right;
  text-transform: capitalize;
  color: #d33030;
}`, "",{"version":3,"sources":["webpack://./src/components/CardNavNew/cardToolbar/settingsModal/inputWithBuiltInValues/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cCUI;ADXN","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.optionsWrapper {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.error {\n  margin-top: 8px;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-align: right;\n  text-transform: capitalize;\n  color: $red;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__nLvrf`,
	"optionsWrapper": `styles_optionsWrapper__d4hUf`,
	"error": `styles_error__GsRv5`
};
export default ___CSS_LOADER_EXPORT___;
